import { get } from 'lodash';
import React, {
	useEffect,useState
} from 'react';

import {
	StyledBody, StyledHeader, UpdatedWrapper,
	Wrapper
} from './styles';


const disclaimer =
  'All patients must complete a virtual consultation, which will be reviewed by a dermatology provider who will determine if a prescription treatment is right for you. If your provider does not deem this medication is appropriate for you, you may be prescribed an alternate treatment.';

export const productData = ({
	patient, type, doctorName, visitCost, rxCredit, isSync, hasLashAndAnyOther,
}) => {
	const {
		subPlan, attribution,
	} = patient;
	if (window && window.Yoderm && window.Yoderm.data && window.Yoderm.data.prePurchase) {
		if (window.Yoderm.data.product_description === 'Latisse') {
			type = 'LATISSE';
		} else {
			type = 'PRODUCT_PURCHASE';
		}
	} else if (type === 'CONSULT' && visitCost === 0) {
		type = 'FREE_VISIT';
	}

	const [price, setPrice] = useState(0);
	const [medication, setMedication] = useState('');

	useEffect(() => {
		if (window && window.Yoderm && window.Yoderm.data) {
			if (window.Yoderm.data.pre_purchase_medication_name) {
				setMedication(window.Yoderm.data.pre_purchase_medication_name.toLowerCase());
			}
			if (window.Yoderm.data.pre_purchase_price_cents) {
				setPrice(window.Yoderm.data.pre_purchase_price_cents / 100);
			}
		}
	});

	const data = {
		MPB: {
			h1: 'Finasteride 1mg',
			description: 'Get prescription finasteride (generic Propecia) delivered directly to your door, on your terms.',
			disclaimer,
		},
		LATISSE: {
			h1: 'Latisse® 3ml',
			description: 'Get prescription Latisse® delivered to your door, on your terms. Cancel anytime.',
			disclaimer,
		},
		LATISSE_AND_OTHER: {
			h1: 'Purchase your treatment & consultation',
			description: 'Your first Apostrophe visit costs $20, which includes your virtual consultation, the creation ' +
				'of your customized treatment plan, and ongoing support from our care team. Get prescription Latisse® ' +
				'delivered to your door, on your terms. Cancel anytime.',
			disclaimer,
		},
		WRINKLE: {
			h1: 'Tretinoin Formula',
			description: 'Get Apostrophe\'s prescription Tretinoin Formula, delivered directly to your door, on your terms.',
			disclaimer,
		},
		WRINKLE_GROUPON: {
			h1: 'Tretinoin Formula',
			description: 'Redeem your Groupon to get Apostrophe\'s prescription Tretinoin Formula.',
			disclaimer,
		},
		CONSULT: {
			h1: 'Start Your Apostrophe Visit',
			description: rxCredit === visitCost ? `Your first Apostrophe visit costs $${visitCost/100}. After your visit, you\'ll be able to apply this $${visitCost/100} credit on your treatment plan purchase.` : `Your first Apostrophe visit costs $${visitCost/100}, which includes your virtual consultation, the creation of your customized treatment plan, and ongoing support from our care team.`,
			disclaimer,
		},
		SYNC_CONSULT: {
			h1: 'Start Your Apostrophe Visit',
			description: visitCost > 0 && rxCredit === visitCost ? `Your first Apostrophe visit costs $${visitCost/100}. After your visit, you\'ll be able to apply this $${visitCost/100} credit on your treatment plan purchase.` : 'First you\'ll upload photos and your medical file for your provider to review. Then you\'ll schedule a quick video chat with your provider to review your personalized treatment plan.',
			disclaimer,
		},
		FREE_VISIT: {
			h1: 'Start Your Apostrophe Visit',
			description: `Your Apostrophe visit is free! You will not be charged for your prescriptions until you receive your custom treatment plan from Dr. ${doctorName} and you approve your medications.`,
		},
		CONSULT_GOOGLE: {
			h1: 'Start Your Apostrophe Journey',
			description: 'We require credit card information up front but you will not be charged until you approve your medications.',
		},
		PRODUCT_PURCHASE: {
			h1: `Purchase ${medication}`,
			description: `Get ${medication} delivered to your door. $${price} for a 3-month supply.`,
			disclaimer,
		},
	};


	if (attribution && attribution == 'GROUPON' && type == 'WRINKLE') {
		return data.WRINKLE_GROUPON
	}

	if (subPlan && subPlan === 'single_latisseStarter') {
		return data.LATISSE;
	}

	if (isSync) {
		if (window && window.Yoderm && window.Yoderm.data && window.Yoderm.data.prePurchase) {
			if (window.Yoderm.data.product_description === 'Latisse') {
				return data.LATISSE;
			} else {
				return data.PRODUCT_PURCHASE;
			}
		}
		return data.SYNC_CONSULT;
	}

	if (hasLashAndAnyOther) {
		type = 'LATISSE_AND_OTHER'
	}

	return data[type];
};

const Header = ({
	type, doctorName, patient, visitCost, rxCredit, isSync=false, hasLashAndAnyOther,
}) => {
	const useUpdatedRegistration = get(window,
		'Yoderm.data.useUpdatedRegistration') || false;

	const productInfo = productData({
		type,
		patient,
		doctorName,
		visitCost,
		rxCredit,
		isSync,
		hasLashAndAnyOther,
	});

	return useUpdatedRegistration ? (
		<UpdatedWrapper>
			<StyledHeader>{productInfo.h1}</StyledHeader>
			<StyledBody className="subheader">
				{productInfo.description}
			</StyledBody>
		</UpdatedWrapper>
	) : (
		<Wrapper>
			<h1>{productInfo.h1}</h1>
			<div className="subheader">
				{productInfo.description}
			</div>
		</Wrapper>
	)
};

export default Header;
